

interface Item<Value extends string> {
    value: Value;
    label: string;
}

interface Props<Value extends string> {
    name?: string;
    header?: string;
    items: Item<Value>[];
    value: Value;
    required?: boolean;
    onChange: (id: Value) => void;
    style?: React.CSSProperties;
}

export function RadioGroup<Value extends string>({
    name,
    header,
    items,
    value,
    onChange,
    required = false,
    style,
}: Props<Value>) {
    return (
        <fieldset className='dialog-form__fieldset'>
            {header && <legend>{header}</legend>}
            {items.map(item => (
                <label key={item.value}>
                    <input
                        className='radio--vert'
                        type='radio'
                        name={name}
                        value={item.value}
                        checked={value === item.value}
                        required={required}
                        onChange={() => onChange(item.value)}
                    />
                    {item.label}
                </label>
            ))}
        </fieldset>
    );
}
